<template>
    <a href  @click.prevent="openUploadModal">
        <slot></slot>
    </a>
</template>

<script>
import { EventBus } from '../../event-bus.js';

export default {
    name: "UploadAhref",
    props: {
        document: { type:Object, required:true }
    },
    methods: {
        openUploadModal() {
            EventBus.$emit('openUploadModal', this.document, 'Edit file');
        }
    }
}
</script>
